import * as React from "react"
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"

export const queryClient = new QueryClient()

/**
 * @type {React.FC<{
 *   children: React.ReactNode,
 * }>}
 */
export const QueryProvider = ({children}) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
)
